var map = {
	"./cust-businessownerspolicy.svg": 809447,
	"./cust-commercialauto.svg": 127748,
	"./cust-commercialpackage.svg": 740823,
	"./cust-commercialproperty.svg": 814770,
	"./cust-commercialumbrella.svg": 827869,
	"./cust-crime.svg": 171955,
	"./cust-dwelling.svg": 422987,
	"./cust-dwelling1.svg": 981920,
	"./cust-generalliability.svg": 700170,
	"./cust-homeowner.svg": 949495,
	"./cust-inlandmarine.svg": 21471,
	"./cust-motorcycle.svg": 276904,
	"./cust-personalauto.svg": 136302,
	"./cust-personalumbrella.svg": 743083,
	"./cust-recvehicle.svg": 845373,
	"./cust-roadtrail.svg": 729359,
	"./cust-watercraft.svg": 432706,
	"./cust-workerscompensation.svg": 981326,
	"./icon/cust-arrow-upward.svg": 975886,
	"./icon/cust-assignment-late.svg": 153333,
	"./icon/cust-check-box.svg": 973485,
	"./icon/cust-double-arrow-left.svg": 879610,
	"./icon/cust-history.svg": 286073,
	"./icon/cust-money.svg": 90985,
	"./icon/cust-percent.svg": 894514,
	"./icon/cust-pie-chart.svg": 294740,
	"./icon/cust-publish.svg": 603412,
	"./icon/cust-remove-circle-outline.svg": 818241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661519;